import {SxType} from '@baseTypes/sx/sxTypes'

export default {
	container: {
		height: '100%',
		p: 3,
		'.lightTheme &': {
			bgcolor: '#fcfcfc',
		},
		paddingBottom: '20px'
	},
	header: {
		display: 'flex',
		justifyContent: {
			xs: 'space-between',
		},
		alignItems: 'center',
		mb: 3,
		width: '100%',
		gap: '20px',
		flexWrap: 'wrap'
	},
	searchField: {
		width: {
			xs: '100%',
			lg: 'calc(100% - 320px)'
		},
		'.lightTheme &': {
			bgcolor: 'white',
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: '8px',
		}
	},
	card: {
		borderRadius: 3,
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		transition: 'transform 0.2s',
		'&:hover': {
			boxShadow: 3,
			borderColor: 'var(--account-accent-tint, rgba(12, 109, 223, 0.35))',
		},
	},
	previewBox: {
		height: 180,
		backgroundColor: 'var(--account-accent-soft, transparent)',
		'.lightTheme &': {
			backgroundColor: 'var(--account-accent-soft, #f2f2ee)',
		},
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderBottom: '1px solid',
		borderColor: 'divider',
	},
	statusDot: (isActive: boolean) => ({
		position: 'absolute',
		top: 12,
		left: 12,
		width: 8,
		height: 8,
		bgcolor: isActive ? 'success.main' : 'text.disabled',
		borderRadius: '50%',
		zIndex: 5,
	}),
	cameraBadge: {
		position: 'absolute',
		bottom: 8,
		right: 8,
		px: 1,
		py: 0.2,
		borderRadius: 1,
		fontSize: '0.75rem',
		fontWeight: 'bold',
		'.lightTheme &': {
			backgroundColor: 'rgba(0, 0, 0, 0.7)',
			color: '#fff',
		},
		zIndex: 5,
	},
	brandChip: (type: string) => ({
		mb: 1,
		fontWeight: 'bold',
		borderRadius: 1,
		color: 'var(--account-accent-text, #1976d2)',
		bgcolor: type === 'MDVR' ? 'var(--account-accent-soft, #e3f2fd)' : 'transparent',
		border: '1px solid',
		borderColor: 'var(--account-accent-tint, #90caf9)',
		height: 24,
	}),
	previewSlot: (count: number) => ({
		width: count === 1 ? '100%' : '50%',
		height: count > 2 ? '50%' : '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		outline: '1px solid',
		outlineColor: 'divider',
		overflow: 'hidden',
		position: 'relative',
	}),
} as const satisfies SxType
